export function classifyMessage({ clientPatterns = [], message, topic }) {
  if (topic.startsWith('$SYS/')) {
    return {
      kind: 'system',
      message: message.toString(),
      topic,
    }
  }

  const payload = parsePayload(message)

  if (topic.includes('/resp/')) {
    return { kind: 'general', payload, topic }
  }

  const match = extractClientAndProperty(topic, clientPatterns)
  if (match.match && match.clientId) {
    return {
      clientId: match.clientId,
      kind: 'client',
      payload,
      propertyParts: match.propertyParts,
      topic,
    }
  }

  return { kind: 'unknown', payload, topic }
}

function extractClientAndProperty(topic, clientPatterns = []) {
  const parts = topic.split('/')

  for (const pattern of clientPatterns) {
    const prefixParts = String(pattern?.prefix || '').split('/')
    const topicPrefix = parts.slice(0, prefixParts.length).join('/')

    if (
      topicPrefix === pattern?.prefix &&
      parts.length > pattern?.clientIndex
    ) {
      const clientId = parts[pattern.clientIndex]
      const propertyParts = parts.slice(pattern.clientIndex + 1)
      return { clientId, match: true, propertyParts }
    }
  }

  return { match: false }
}

function parsePayload(message) {
  try {
    return JSON.parse(message.toString())
  } catch {
    return message.toString()
  }
}

export { extractClientAndProperty }
